// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"954e5551","949":"26d27142"}[chunkId] + ".chunk.js";
};